import { css } from "styled-components";

// Media Query Breakpoints
const sizes = {
  small: 768,
  medium: 996,
  large: 1200,
};

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

export { media };
